import HTTP from "../../http";

const CART_ENDPOINT = "/carts/";
const GET_HYDRATED_CART_ENDPOINT = "/hydrated";

export async function getHydratedCart(cartId) {
  return await HTTP.get(CART_ENDPOINT + cartId + GET_HYDRATED_CART_ENDPOINT, {
    headers: { "Content-Type": "application/json" }
  });
}
